import { render } from "./RiProdoffering187.vue?vue&type=template&id=6a952294"
import script from "./RiProdoffering187.vue?vue&type=script&lang=js"
export * from "./RiProdoffering187.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sc/display/scIcon/iconDist/RiProdoffering187.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a952294"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a952294', __exports__)) {
    api.reload('6a952294', __exports__)
  }
  
  module.hot.accept("./RiProdoffering187.vue?vue&type=template&id=6a952294", () => {
    api.rerender('6a952294', render)
  })

}


export default __exports__